const addUserFormModel = {
  formId: "addUserForm",
  formField: {
    tenantName: {
      name: "tenantName",
      label: "labels.workspaceName",
    },
    displayName: {
      name: "displayName",
      label: "labels.workspaceName",
    },
    email: {
      name: "email",
      label: "labels.email",
    },
    confirmEmail: {
      name: "confirmEmail",
      label: "labels.confirmEmail",
    },
    userType: {
      name: "userType",
      label: "labels.userType",
    },
  },
};

export default addUserFormModel;
